import { AccessRule } from 'domain/models/AttendeeFormSchema/AccessRule'
import { MaybeRequiredParticulars } from 'domain/models/AttendeeFormSchema/MaybeRequiredParticulars'
import { Enum } from 'helpers/enum'

export type AttendeeAgeStatus = 'MINOR' | 'ADULT' | 'UNKNOWN'

export const AttendeeAgeStatus: Enum<AttendeeAgeStatus> = {
  MINOR: 'MINOR',
  ADULT: 'ADULT',
  UNKNOWN: 'UNKNOWN'
}

export interface MakeAttendeeFormSchemaContext {
  extendedRequiredParticulars: Record<MaybeRequiredParticulars, boolean>
  accessRule: AccessRule
  minAgeRequirement?: Date
  maxAgeRequirement?: Date
  /**
   * Will be available as soon as user enters a valid date
   */
  attendeeAgeStatus: AttendeeAgeStatus
  registrationOpeningDate: Date
  raceDate: Date
}
